import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Heart, CheckCircleIcon } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="pt-8 pb-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-cream to-cream-secondary" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-61">
          <Heart className="w-12 h-12 text-rose-soft mx-auto mb-6" strokeWidth={1.5} data-id="element-62" />
          <h2 className="text-3xl sm:text-4xl font-heading text-text-dark leading-tight mb-6" data-id="element-63">
            No permitas que el recuerdo de la infancia de tus hijos sea el ruido
            de tus gritos.
          </h2>
          <p className="text-xl text-text-medium font-heading italic" data-id="element-64">
            Tú puedes ser la madre firme, amorosa y segura que ellos necesitan.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} id="offer-card" className="bg-white p-8 sm:p-12 rounded-3xl shadow-xl border border-gold/20 relative overflow-hidden" data-id="element-65">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-66"></div>

          <div className="relative z-10" data-id="element-67">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-68">
              Obtén "El Método de la Pausa Consciente" hoy
            </h3>

            <div className="max-w-sm mx-auto mb-8 space-y-3 text-left" data-id="element-69">
              {['Acceso inmediato al material digital', 'Método práctico de 7 días', 'Herramientas para momentos de crisis reales', 'Lectura rápida y aplicación inmediata'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-70">
                  <CheckCircleIcon className="w-5 h-5 text-gold-dark flex-shrink-0 mt-0.5" data-id="element-71" />
                  <span className="text-text-dark text-base leading-relaxed" data-id="element-72">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="my-8" data-id="element-73">
              <span className="text-6xl font-bold text-gold-dark font-heading" data-id="element-74">
                $8.97
              </span>
              <span className="text-text-medium ml-2" data-id="element-75">USD</span>
            </div>

            <p className="text-text-medium mb-8 max-w-md mx-auto" data-id="element-76">
              Pago único. Acceso inmediato. Producto 100% digital.
            </p>

            <a href="https://www.upreferr.com/cart/44014402404487:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="inline-block w-full sm:w-auto px-8 py-5 bg-gold hover:bg-gold-dark text-text-dark font-bold text-lg sm:text-xl rounded-full shadow-[0_8px_20px_rgba(197,165,90,0.3)] hover:shadow-[0_12px_25px_rgba(197,165,90,0.4)] transform transition-all duration-300 hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-gold-light text-center" data-id="element-77">
              QUIERO RECUPERAR LA PAZ EN MI HOGAR
            </a>

            <div className="mt-8 flex items-center justify-center gap-2 text-sm text-text-medium" data-id="element-78">
              <Shield className="w-4 h-4 text-gold-dark" data-id="element-79" />
              <span data-id="element-80">Pago seguro • Acceso inmediato • Sin envío físico</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}